import { db } from '../../utils/firebase';

export const getAllAlumni = async () => {
  const querySnapshot = await db.collection("alumni").get();

  const contents = [];
  querySnapshot.forEach(doc => {
    // doc.data() is never undefined for query doc snapshots
    let { title, order, content } = doc.data();
    if (content == null) content = [];

    contents.push({ title, content, order });
  });

  contents.sort((a, b) => a.order - b.order);
  return contents;
}
